import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { RouterModule } from '@angular/router';
import {  IonRouterOutlet, IonSegment, IonSegmentButton, IonLabel, IonButtons, IonMenuButton } from '@ionic/angular/standalone';

import { ManageHubPage } from './manage-hub/manage-hub.page';

@Component({
  selector: 'app-hubs',
  templateUrl: './hubs.page.html',
  styleUrls: ['./hubs.page.scss'],
  standalone: true,
  imports: [ManageHubPage ,IonContent, RouterModule, IonRouterOutlet, IonHeader, IonTitle, IonToolbar, CommonModule, FormsModule, IonSegment, IonSegmentButton, IonLabel, IonButtons, IonMenuButton]
})
export class HubsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
